import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { ISchoolYear, ISchoolYearDTOIn, ISchoolYearDtoOut } from '../interfaces/groups/school-year.interface';

@Injectable({
    providedIn: 'root',
})
export class SchoolYearsService {
    constructor(private http: HttpClient) {}

    public getAllSchoolYears(studentId?: number): Observable<ISchoolYear[]> {
        let params: HttpParams = new HttpParams();
        if (studentId) {
            params = params.set('viewing_student_id', studentId);
        }
        return this.http
            .get<ISchoolYearDTOIn>(environment.wasoApi + SubUrlsEnum.SCHOOL_YEARS, { params: studentId ? params : null })
            .pipe(map((schoolYear: ISchoolYearDTOIn) => schoolYear.school_years));
    }

    public createSchoolYear(schoolYear: ISchoolYearDtoOut): Observable<ISchoolYear> {
        return this.http.post<ISchoolYear>(environment.wasoApi + SubUrlsEnum.SCHOOL_YEARS, { school_year: schoolYear });
    }

    public migrateDataToNextYear(schoolId: number): Observable<any> {
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.MIGRATE.replace('{{id_school}}', schoolId.toString()), {});
    }
}
